import { Component } from '@angular/core';
import {TitleControllerService} from "./services/title-controller.service"

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [TitleControllerService]
})
export class AppComponent {
  title = 'app';
  demo : string = "123";
  constructor(private titleController: TitleControllerService)
  {

  }
  UpdateTitle()
  {
    console.log("Yappi 3");
    this.titleController.setTitle(this.demo);
    console.log("Yappi 1");
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts